import { validateCallback } from "../validateCallback";
import { missingNativeBuild } from "../nativeError";
var Purchases = Object.freeze({
  getProducts: function getProducts(_productIds) {
    return Promise.resolve([]);
  },
  purchase: function purchase(_productId, _appAccountToken) {
    return Promise.reject(missingNativeBuild("Purchases.purchase"));
  },
  getCurrentEntitlements: function getCurrentEntitlements() {
    return Promise.reject(missingNativeBuild("Purchases.getCurrentEntitlements"));
  },
  getUnfinishedTransactions: function getUnfinishedTransactions() {
    return Promise.reject(missingNativeBuild("Purchases.getUnfinishedTransactions"));
  },
  finishTransaction: function finishTransaction(_transactionId) {
    return Promise.reject(missingNativeBuild("Purchases.finishTransaction"));
  },
  addTransactionListener: function addTransactionListener(onUpdate) {
    validateCallback(onUpdate, "Purchases.addTransactionListener requires a function");
    return function() {
    };
  },
  sync: function sync() {
    return Promise.reject(missingNativeBuild("Purchases.sync"));
  }
});
export {
  Purchases
};
//# sourceMappingURL=unavailable.js.map
